import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Manage your payees',
	addPayeeButtonTitle: 'Add new payee',
	deleteTemplateModalTitle: 'Are you sure you want to delete this payee?',
	deleteTemplateModalSafeActionButton: "No, don't delete",
	deleteTemplateModalDestructiveActionButton: 'Yes, delete',
	noSearchResultMessage: 'No results',
	infoText:
		"You're about to delete the following payee. This won't affect any scheduled payments you currently have set up for them.",
	scheduledPayementInfoText:
		'If you want to cancel a payment to this payee, like a Direct Debit or standing order, you can do this by managing your',
	scheduledPayementLink: 'Scheduled payments',
	importNowButton: 'Import now',
	payeeListTitle: 'Your payees',
	deletePayeeSuccessMessage: 'has now been deleted from your list of payees.',
	domesticPayeeTypeLabel: 'UK',
	internationalPayeeTypeLabel: 'International',
	fileImportHeader: 'Import payees',
	fileImportText: 'Load up to {maxRecords} payees from a CSV or TXT file.',
	instructionsURLText: 'Read instructions (PDF)',
	templateURLText: 'Download an example (XLSX)',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
